import NProgress from 'nprogress';
import { useEffect, useState, useRef } from 'react';
// routes
import { usePathname } from 'src/routes/hooks';
//
import StyledProgressBar from './styles';

// ----------------------------------------------------------------------

export default function ProgressBar() {
  const pathname = usePathname();
  const [mounted, setMounted] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    // Configurer NProgress pour être plus rapide
    NProgress.configure({
      showSpinner: false,
      trickleSpeed: 200,
      minimum: 0.1,
      easing: 'ease',
      speed: 300,
    });

    // Démarrer la barre immédiatement
    NProgress.start();

    // Utiliser un debounce pour arrêter la barre après que la navigation est complète
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      NProgress.done();
    }, 100); // Court délai pour que la transition soit visible mais rapide

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [pathname]);

  if (!mounted) {
    return null;
  }

  return <StyledProgressBar />;
}
